(function(algolia) {
    'use strict';
    // algolia_autocomplete Start -->
  

    algolia.mainTemplate = function mainTemplate({ html, state }, elements, displaySuggestions ) {
      return html `<div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSections">
          <div class="aa-PanelSection--left">
            ${displaySuggestions &&
            html`<div class="aa-SourceHeader">
              <span class="aa-SourceHeaderTitle">Suggestions</span>
              <div class="aa-SourceHeaderLine" />
            </div>
            ${elements.querySuggestionsPlugin}`}
            ${elements.collections}
            ${elements.articles}
            ${elements.pages}
          </div>
          <div class="aa-PanelSection--right">
            ${elements.products}
          </div>
        </div>
      </div>`
    };
  
    // algolia_autocomplete End -->
  
    // algolia_autocomplete_main_products_only Start -->
    algolia.mainProductsTemplate = function mainProductsTemplate({ html, state }, elements) {
      return html `<div class="aa-PanelLayout aa-Panel--scrollable">
        <div class="aa-PanelSection">
            ${elements.products}
        </div>
      </div>`
    };
    // algolia_autocomplete_main_products_only End -->
  
    // algolia_autocomplete_page Start -->
    algolia.pagesTemplate = function pagesTemplate({ item, html, components }, itemLink) {
      return html `<a
              href="${itemLink}"
              class="aa-ItemLink aa-ProductItem"
      >
        <div class="aa-ItemWrapper">
            <div class="aa-ItemContent">
                <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                        <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                        />
                    </svg>
                </div>
                <div class="aa-ItemContentBody">
                    <div class="aa-ItemContentTitle">
                        ${components.Highlight({ hit: item, attribute: 'title' })}
                    </div>
                </div>
            </div>
        </div>
      </a>`
    };
    // algolia_autocomplete_page End -->
  
    // algolia_autocomplete_collection Start -->
    algolia.collectionsTemplate = function collectionsTemplate({ item, html, components }, itemLink) {
        return html `<a
                href="${itemLink}"
                class="aa-ItemLink"
        >
            <div class="aa-ItemWrapper">
                <div class="aa-ItemContent">
                    <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                            <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z"
                            />
                        </svg>
                    </div>
                    <div class="aa-ItemContentBody">
                        <div class="aa-ItemContentTitle">
                            ${components.Highlight({ hit: item, attribute: 'title' })}
                        </div>
                    </div>
                </div>
            </div>
        </a>`
    };
    // algolia_autocomplete_collection End -->
  
    // algolia_autocomplete_article Start -->
    algolia.articlesTemplate = function articlesTemplate({ item, html, components }, itemLink) {
          return html `<a
                  href="${itemLink}"
                  class="aa-ItemLink"
          >
              <div class="aa-ItemWrapper">
                  <div class="aa-ItemContent">
                      <div class="aa-ItemIcon aa-ItemIcon--noBorder">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
                              <path
                                  stroke-linecap="round"
                                  stroke-linejoin="round"
                                  stroke-width="2"
                                  d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z"
                              />
                          </svg>
                      </div>
                      <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">
                              ${components.Highlight({ hit: item, attribute: 'title' })}
                          </div>
                      </div>
                  </div>
              </div>
          </a>`
      };
    // algolia_autocomplete_article End -->
  
    // algolia_autocomplete_product Start -->
    algolia.productTemplate = function productTemplate({ item, html, components, insights }, distinct, itemLink, getConversionData) {
      return html `<a
              href="${itemLink}"
              class="aa-ItemLink aa-ProductItem"
              onClick="${(event) => getConversionData(event, item)}"
      >
          <div class="aa-ItemContent">
              <div class="aa-ItemPicture aa-ItemPicture--loaded">
                  <img src="${algolia.helpers.compactImage(item)}" alt="${item.title}" />
              </div>
              <div class="aa-ItemContentBody">
                  <div class="aa-ItemContentBrand">
                      ${item.product_type && components.Highlight({ hit: item, attribute: 'product_type' })}
                      ${item.vendor && html`<span> by </span>`}
                      ${item.vendor && components.Highlight({ hit: item, attribute: 'vendor' })}
                  </div>
                  <div class="aa-ItemContentTitleWrapper">
                      <div class="aa-ItemContentTitle">
                          ${components.Highlight({ hit: item, attribute: 'title' })}
                          <span class="algolia-variant">
                            ${algolia.helpers.variantTitleAddition (item, distinct)}
                          </span>
                      </div>
                  </div>
                  <div class="aa-ItemContentPrice">
                      <div class="aa-ItemContentPriceCurrent">
                          ${algolia.helpers.displayPrice(item, distinct)}
                      </div>
                  </div>
              </div>
          </div>
      </a>`
    };
    // algolia_autocomplete_product End -->
  
    // algolia_autocomplete_suggestion Start -->
    algolia.suggestionsTemplate = function suggestionsTemplate({ item, html, components }) {
      return html`<a
              class="aa-ItemLink aa-ItemWrapper"
              href="/search?q=${item.query}"
      >
        <div class="aa-ItemContent">
          <div class="aa-ItemIcon aa-ItemIcon--noBorder">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <path d="M16.041 15.856c-0.034 0.026-0.067 0.055-0.099 0.087s-0.060 0.064-0.087 0.099c-1.258 1.213-2.969 1.958-4.855 1.958-1.933 0-3.682-0.782-4.95-2.050s-2.050-3.017-2.050-4.95 0.782-3.682 2.050-4.95 3.017-2.050 4.95-2.050 3.682 0.782 4.95 2.050 2.050 3.017 2.050 4.95c0 1.886-0.745 3.597-1.959 4.856zM21.707 20.293l-3.675-3.675c1.231-1.54 1.968-3.493 1.968-5.618 0-2.485-1.008-4.736-2.636-6.364s-3.879-2.636-6.364-2.636-4.736 1.008-6.364 2.636-2.636 3.879-2.636 6.364 1.008 4.736 2.636 6.364 3.879 2.636 6.364 2.636c2.125 0 4.078-0.737 5.618-1.968l3.675 3.675c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414z" />
            </svg>
          </div>
          <div class="aa-ItemContentBody">
            <div class="aa-ItemContentTitle">
              ${components.Highlight({ hit: item, attribute: 'query' })}
            </div>
          </div>
        </div>
        <div class="aa-ItemActions">
          <button
            class="aa-ItemActionButton"
            title={"Fill query with ${item.query}"} >
              <svg viewBox="0 0 24 24" fill="currentColor">
                <path d="M8 17v-7.586l8.293 8.293c0.391 0.391 1.024 0.391 1.414 0s0.391-1.024 0-1.414l-8.293-8.293h7.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-10c-0.552 0-1 0.448-1 1v10c0 0.552 0.448 1 1 1s1-0.448 1-1z" />
              </svg>
          </button>
        </div>
      </a>`
    };
    // algolia_autocomplete_suggestion End -->
  
    // algolia_autocomplete_header Start -->
    algolia.headerTemplate = function headerTemplate({ html, state }, resource) {
        return html `<div class="aa-SourceHeader">
            <span class="aa-SourceHeaderTitle">${algolia.translation_helpers.render_title(resource, state.query)}</span>
            <div class="aa-SourceHeaderLine" />
        </div>`
    };
    // algolia_autocomplete_header End -->
  
    // algolia_autocomplete_footer Start -->
    algolia.footerTemplate = function footerTemplate({ html, state }) {
        return html `<div class="aa-footer">
            <a class="aa-SeeAllBtn" href="/search?q=${state.query}">
                ${algolia.translations.allProducts}
                (${algolia.helpers.formatNumber(state.context.nbProducts)})
            </a>
        </div>`
    };
    // algolia_autocomplete_footer End -->
  
    // algolia_autocomplete_no_results Start -->
    algolia.noResultsTemplate = function noResultsTemplate({ html, state }) {
       return html `<div class="aa-PanelLayout aa-Panel--scrollable">
          <p class="aa-NoResultsHeader">
             ${algolia.translation_helpers.no_result_for(state.query)}
          </p>
          <a class="aa-NoResultsLink" href="/search?q=">
              ${algolia.translations.allProducts}
          </a>
       </div>`
    };
    // algolia_autocomplete_no_results End -->
    
    // algolia_instant_search Start -->
    algolia.instantSearchMainTemplate = function instantSearchMainTemplate( html, data ) {
      let window_w = window.innerWidth;
      let btn_text = window_w > 1024 ? 'Hide Filter' : 'Show Filter';
      let hide_class = window_w > 1024 ? '' : 'hide-filter';
      
      return html `<div class="ais-page ${hide_class}">
        <div class="ais-facets-button">
          Show filters
        </div>
        <div class="ais-top">
          <div class="ais-top-left">
            <button class="hide-filter-btn"><span>${btn_text}</span></button>
            <label class="ais-quick-show-btn"><input type="checkbox" id="ais-quick-show-input" /> <span class="icon"></span> <span class="label">Quick Ship</span></label>
          </div>
          <div class="ais-top-right"><h1 class="ais-h2">${searchTitle}</h1></div>
        </div>
        <div class="ais-facets">
          
          ${data.facets.map( facet =>
        html`<div class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}">
              <label for="${facet.escapedName}" class="ais-range-slider--header ais-facet--header ais-header">${facet.title}</label>
              <input class="ais-dropdown-checkbox" type="checkbox" id="${facet.escapedName}" name="dropdown" />
              <div class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"></div>
            </div>`
      )}
        </div>
        <div class="ais-block">
          <div class="ais-page-search-wrapper">
            
            <div class="ais-input">
              <div class="ais-search-box-container"></div>
              <div class="ais-input-button">
                <div class="ais-clear-input-icon"></div>
              </div>
            </div>
          </div>
          <div class="ais-search-header">
            <div class="ais-stats-container"></div>
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"><i class="fa fa-th-large"></i></span>
              <span class="ais-change-display-list"><i class="fa fa-th-list"></i></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders ?
                html`${algolia.translations.sortBy} <span class="ais-sort-orders-container"></span>`
                : html`${algolia.translations.sortBy} ${algolia.translations.relevance}`
              }
            </div>
          </div>
          <div class="ais-current-refined-values-container-wrapper">
            <div class="ais-clear-refinements-container"></div>
            <div class="ais-current-refined-values-container"></div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
          <div class="ais-pagination-container"></div>
        </div>
        
        
      </div>`
    };
    // algolia_instant_search End -->
  
    // algolia_instant_search_stats Start -->
    algolia.instantSearchStatsTemplate = function instantSearchStatsTemplate(data, html) {
      return html `${data.hasNoResults && algolia.translations.noResultFound}
        ${data.hasOneResult &&
        html`<span class="ais-stats--nb-results">
            ${algolia.translations.oneResultFound}
        </span>`}
        ${data.hasManyResults &&
        html`${algolia.translation_helpers.outOf(data.page, data.hitsPerPage, data.nbHits)}
        <span class="ais-stats--nb-results">
          ${' '}
          ${algolia.helpers.formatNumber(data.nbHits)}
          ${' '}
          ${algolia.translations.resultsFound}
        </span>`}
        ${' '}
        ${algolia.translation_helpers.in(data.processingTimeMS)}`
    };
    // algolia_instant_search_stats End -->
  
    // algolia_instant_search_facet_show_more Start -->
    algolia.instantSearchShowMore = function instantSearchShowMore(data, html) {
      return html `<span>${data.isShowingMore ? algolia.translations.showLess : algolia.translations.showMore }</span>`
    };
    // algolia_instant_search_facet_show_more End -->
  
    // algolia_instant_search_facet_item Start -->
    algolia.instantSearchFacetItem = function instantSearchFacetItem(item, html) {
      return html `<label class="${item.cssClasses.label}">
          ${item.type === "disjunctive" &&
          (item.isRefined ?
                html`<input type="checkbox" class="${item.cssClasses.checkbox}" checked />`
                : html`<input type="checkbox" class="${item.cssClasses.checkbox}"  />`)
          }
          ${ item.label}
          <span class="${item.cssClasses.count}">
            ${algolia.helpers.formatNumber(item.count)}
          </span>
      </label>`
    };
    // algolia_instant_search_facet_item End -->
  
    // algolia_instant_search_product Start -->
    algolia.instantSearchProductTemplate = function instantSearchProductTemplate(hit, html, components) {
      return html `<div data-algolia-index="${hit.index}" data-algolia-position="${hit.productPosition}" data-algolia-queryid="${hit.queryID}" data-algolia-objectid="${hit.objectID}" class="ais-hit ais-product" data-handle="${hit.handle}" data-variant-id="${hit.objectID}" data-distinct="${hit._distinct}">
        <div class="ais-hit--picture" style="background-image: url('${algolia.helpers.mediumImage(hit)}')">
          ${hit.price_ratio !== 1 && html`<div class="ais-Discount-label">${hit._distinct && html`<span class="ais-hit--price-discount">${algolia.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)}</span>`}</div>`}
        </div>
        <div class="ais-hit--details">
          <p class="ais-hit--subtitle" title="${hit.product_type}${algolia.translation_helpers.by(hit.vendor)}">
            ${hit.vendor && components.Highlight({ attribute: 'vendor', hit })}
          </p>
          <div class="ais-hit--price-div">
            <p class="ais-hit--price"> 
              ${hit.variants_min_price == hit.variants_max_price ? algolia.formatMoney(Number(hit.variants_min_price) * 100) : html`From: ${algolia.formatMoney(Number(hit.variants_min_price) * 100)}`}
            </p>
            <p class="ais-hit--price--strikethrough">
              ${hit._distinct && html`<span class="ais-hit--price-striked"><span>${hit.price == hit.variants_min_price && hit.price_ratio !== 1 && algolia.helpers.displayStrikedPrice(hit.price, hit.compare_at_price)}</span></span>`}
            </p>
            ${hit.price_ratio !== 1 && html`<p class="ais-hit--price--mobile">${algolia.helpers.displayDiscount(hit.price, hit.compare_at_price, hit.price_ratio)} </p>`}
          </div>
          <p class="ais-hit--title">
            <a data-algolia-index="${hit.index}"
               data-algolia-position="${hit.productPosition}"
               data-algolia-queryid="${hit.queryID}"
               data-algolia-objectid="${hit.objectID}"
               href="${algolia.helpers.instantsearchLink(hit)}"
               onclick="void(0)"
               title="${algolia.helpers.fullTitle(hit.title, hit._distinct, hit.variant_title)}">
              ${components.Highlight({ attribute: 'title', hit })}
              ${algolia.helpers.variantTitleAddition (hit, hit._distinct)}
            </a>
          </p>
          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku && html`<span class="algolia-sku">${components.Highlight({ attribute: 'sku', hit })}</span>`}
            ${hit.barcode && html`<span class="algolia-barcode">${components.Highlight({ attribute: 'barcode', hit })}</span>`}
            ${hit.weight && html`<span class="algolia-weight">${hit.weight}</span>`}
            ${!hit.taxable && html`<span class="algolia-taxable">Tax free</span>`}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
                  ${hit._highlightResult.tags?.map( tag => html`<span class="ais-hit--tag">${tag.value}</span>`)}
          </p>
              ${!hit._distinct && html`
              <form id="algolia-add-to-cart-${hit.objectID}" style="display: none;" action="/cart/add" method="post" enctype="multipart/form-data">
                  <input type="hidden" name="id" value="${hit.objectID}" />
              </form>`}
          </div>
      </div>`
    };
    // algolia_instant_search_product End -->
  
    // algolia_instant_search_no_result Start -->
    algolia.instantSearchNoResultTemplate = function instantSearchNoResultTemplate(html) {
      return html `<div class="ais-hit-empty">
        <div class="ais-hit-empty--title">${algolia.translations.noResultFound}</div>
        <div class="ais-hit-empty--clears">
          ${algolia.translations.try}
          ${' '}
          <a class="ais-hit-empty--clear-filters ais-link">
              ${algolia.translations.clearFilters}
              ${' '}
          </a>
          ${algolia.translations.or}
          ${' '}
          <a class="ais-hit-empty--clear-input ais-link">
              ${algolia.translations.changeInput}
          </a>
        </div>
      </div>`
    };
    // algolia_instant_search_no_result End -->
})(algoliaShopify);

let ifElement = (e, _class, _callback)=> {
    let ele = e.target;
    let _ele = null;
    if(ele.classList.contains(_class)) {
      _ele = ele;
    }
    else if(ele.closest(`.${_class}`)) {
      _ele = ele.closest(`.${_class}`);
    }
    
    _ele && _callback && _callback(_ele);
  };
  
  document.querySelector('body').addEventListener('click', (e)=> {
    ifElement(e, 'hide-filter-btn', (ele)=> {
      let ais_page = document.querySelector('.ais-page');
      if(ais_page.classList.contains('hide-filter')) {
        ais_page.classList.remove('hide-filter');
        ele.innerHTML = '<span>Hide Filter</span>';
      }
      else {
        ais_page.classList.add('hide-filter');
        ele.innerHTML = '<span>Show Filter</span>';
      }
    });

    ifElement(e, 'quick-ship', (ele)=> {
      document.getElementById("ais-quick-show-input").checked = false;
    });
  }, false);

  document.querySelector('body').addEventListener('change', (e)=> {
    if(e.target === document.getElementById('ais-quick-show-input')) {
      console.log(e.target);
      document.querySelector('.ais-facet-named_tags\\.quickship .ais-facet--label').click();
    }
  }, false);

  document.addEventListener('DOMContentLoaded', ()=> {
    if(decodeURIComponent(window.location.search).includes('named_tags.quickship')) {
      document.getElementById("ais-quick-show-input").checked = true;
    }
  }, false);